import { Box, CircularProgress, Typography, styled } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import logo from "../assets/images/logo.svg";

const Image = styled("img")``;
const Loader = () => {
  return (
    <>
      <Helmet>
        <title>{process.env.REACT_APP_NAME}</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Image src={logo} width={"35px"} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            position: "absolute",
          }}
        >
          <CircularProgress color="primary" size={60} thickness={1.5} />
        </Box>
      </Box>
    </>
  );
};

export default Loader;
